import {
  YT_PLAYER_STATE,
  YouTubePlayerStateChange,
} from 'hooks/useYouTubePlayer';

export interface WatchSummary {
  seconds_watched: number;
  video_duration_seconds: number;
  percent_watched: number;
  completed: boolean;
}

// Counts only time spent in the PLAYING state, so pausing, buffering and
// scrubbing don't inflate it.
export const createWatchTimer = (now: () => number = () => Date.now()) => {
  let playingSince: number | null = null;
  let watchedMs = 0;
  let duration = 0;
  let completed = false;

  const pause = () => {
    if (playingSince === null) return;
    watchedMs += now() - playingSince;
    playingSince = null;
  };

  return {
    onStateChange: ({ state, duration: d }: YouTubePlayerStateChange) => {
      if (d > 0) duration = d;
      if (state === YT_PLAYER_STATE.PLAYING) {
        if (playingSince === null) playingSince = now();
        return;
      }
      pause();
      if (state === YT_PLAYER_STATE.ENDED) completed = true;
    },
    stop: (): WatchSummary => {
      pause();
      const seconds = Math.round(watchedMs / 1000);
      return {
        seconds_watched: seconds,
        video_duration_seconds: Math.round(duration),
        percent_watched: duration
          ? Math.min(100, Math.round((seconds / duration) * 100))
          : 0,
        completed,
      };
    },
  };
};
